/* Nur Typen aus dem Paket; die Werte kommen über den Quellpfad (siehe Kopf von @crm/kontrakte/src/fehlerablage). */
import type { Fehlerbereich, Fehlerzeile, Fehlerzustand } from '@crm/kontrakte/src/fehlerablage';

import { rufe } from './client';

export type { Fehlerbereich, Fehlerzeile, Fehlerzustand };

/** Die Filter der Liste. Was fehlt, filtert nicht. */
export type Fehlerfilter = {
  readonly bereich?: Fehlerbereich | undefined;
  readonly zustand?: Fehlerzustand | undefined;
};

/**
 * ERR-07: die Einträge der Fehlerablage.
 *
 * `hintergrund` für den Abruf im Takt der Seite: Er hält die Sitzung nicht
 * wach (BEN-07).
 */
export async function liste(filter: Fehlerfilter = {}, hintergrund = false): Promise<readonly Fehlerzeile[]> {
  const abfrage = new URLSearchParams();
  if (filter.bereich !== undefined) abfrage.set('bereich', filter.bereich);
  if (filter.zustand !== undefined) abfrage.set('zustand', filter.zustand);
  const text = abfrage.toString();
  const antwort = await rufe<{ readonly eintraege: readonly Fehlerzeile[] }>(
    text === '' ? '/fehlerablage' : `/fehlerablage?${text}`,
    { hintergrund },
  );
  return antwort.eintraege;
}

/**
 * ERR-07: erneut auslösen, ohne Neuerfassung.
 *
 * NOCH-OFFEN ERR-07: Die API kennt den Weg zurück bisher nur für Navision
 * (AP-SQ-09); die übrigen Bereiche antworten mit `bereich_ohne_weg`.
 */
export async function wiederholen(id: string): Promise<void> {
  await rufe<{ readonly angestossen: true }>(`/fehlerablage/${encodeURIComponent(id)}/wiederholen`, {
    verfahren: 'POST',
  });
}

/** ERR-07: den Eintrag schließen — beim Verwerfen mit Pflichtgrund. */
export async function abschliessen(
  id: string,
  zustand: 'erledigt' | 'verworfen',
  grund: string | null = null,
): Promise<void> {
  await rufe<void>(`/fehlerablage/${encodeURIComponent(id)}/abschluss`, {
    verfahren: 'POST',
    rumpf: { zustand, grund },
  });
}
